<template>
  <common-service-modal
    :open="open"
    titleName="FitBack健康吧"
    @close="$emit('close')"
  >
    <div class="row" :class="{'section-loading': isQueryType8}">
      <table class="table insurance-green">
        <thead>
          <tr>
            <th class="text-center">會員註冊及數據綁定狀態</th>
            <th class="text-center">註冊日期</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center">
              <span v-if="tableData.create_tm">已註冊</span>
              <span style="color: red;" v-if="!tableData.create_tm">尚未註冊</span>
              ，
              <span v-if="tableData.health_source == 'Y'">已開通數據</span>
              <span style="color: red;" v-if="tableData.health_source == 'N'">未開通數據</span>
            </td>
            <td class="text-center">{{tableData.create_tm | dateFormat}}</td>
          </tr>
        </tbody>
      </table>
      <br />&nbsp;
      <table class="table insurance-green">
        <thead>
          <tr>
            <th class="text-center">會員等級</th>
            <th class="text-center">當前任務值</th>
            <th class="text-center">會員年度到期日</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center">{{tableData.level_nm}}</td>
            <td class="text-center">{{tableData.experience | numberFormat}}<br>
              <div v-if="tableData.experience !== '— —'">
                <span style="color: #F58818;" v-if="tableData.experience < 12000">再{{tableData.upgrade_exp | numberFormat}}分{{tableData.upgrade_msg | numberFormat}}{{tableData.upgrade_nm | numberFormat}}
                </span>
                <span style="color: #F58818;" v-else>已為最高等級</span>
              </div>
            </td>
            <td class="text-center">{{tableData.end_dt | dateFormat}}</td>
          </tr>
        </tbody>
      </table>
      <table id="recommendTable">
        <tr>
          <td>
            <span style="font-size:20px;font-weight:600">我的專屬推薦碼：</span>
            <span style="font-size:20px;font-weight:600">{{tableData.invitecode}}</span>
          </td>
          <td>
            <input
              type="text"
              style="position:absolute;left:-10000px;top:-10000px"
              id="copyText"
            />
            <button type="button" class="btn btn-default btn-sm" @click="copy(tableData.invitecode)">複製</button>
            <button type="button" class="btn btn-default btn-sm" @click="copy('揪你加入「FitBack健康吧」健康計劃，點連結下載(開啟)國泰人壽APP並登入，再依步驟綁定就可以囉！' + tableData.inviteurl)">分享連結</button>
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <td>※「FitBack健康吧」註冊及綁定教學：</td>
        </tr>
        <tr>
          <td>進入國泰人壽APP點選下方「健康吧」，填寫身高與體重並勾選個資同意書，並選擇一個開通數據來源，以存取健康數據，各裝置綁定教學，請參考【
            <a href="https://www.cathaylife.com.tw/cathaylife/-/media/079982D14F954B478B93E139FC5289FB.pdf?sc_lang=zh-TW&amp;_gl=1*kviwbs*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzc4OTIuNDMuMC4w" target="_blank" class="link">iOS</a>】、【
            <a href="https://www.cathaylife.com.tw/cathaylife/-/media/D6AE7FE55F0044508B0304CD8378B441.pdf?sc_lang=zh-TW&amp;_gl=1*m3w979*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1NjMuNjAuMC4w" target="_blank" class="link">Android</a>】、【
            <a href="https://www.cathaylife.com.tw/cathaylife/-/media/9E9D6249B12B4A69805F5D3984896466.pdf?sc_lang=zh-TW&amp;_gl=1*qvu4j7*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1ODEuNDIuMC4w" target="_blank" class="link">Garmin</a>】、【
            <a href="https://www.cathaylife.com.tw/cathaylife/-/media/34C29FC89AF349488CBE0E30E178A016.pdf?sc_lang=zh-TW&amp;_gl=1*1n62wtd*_ga*MTA0MDU2ODcwNi4xNzM1MTc2MTQy*_ga_BQ2KWMRPRE*MTczODczNzg3NS40NC4xLjE3Mzg3Mzg1OTIuMzEuMC4w" target="_blank" class="link">Fitbit</a>】教案。
          </td>
        </tr>
      </table>
    </div>
  </common-service-modal>
</template>

<script>
import CommonServiceModal from "./CommonServiceModal";
import { getCustFITBACK } from "../../../../service";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";

export default {
  name: "FitBackModal",
  components: {
    CommonServiceModal
  },
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custId: { 
      type: String, 
      default: "" 
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  data() {
    return {
      tableData: {},
      isQueryType8: false
    };
  },
  watch: {
    open: "getService"
  },
  methods: {
    // 查詢 FitBack 資料
    async getFitbackData() {
      this.isQueryType8 = true;
      await getCustFITBACK(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.custId,
        ""
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.tableData = result.body.memberfitbacklist.fitback;
          this.isQueryType8 = false;
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({
              title: "查詢會員FITBACK資料失敗,請重新操作"
            });
          }
        }
      });
    },

    async getService() {
      if (this.open) {
        await this.getFitbackData();

        if (this.tableData.level == 0) {
          this.tableData.level_nm = "— —";
          this.tableData.experience = "— —";
        }
        if (this.tableData.inviteurl) {
          let Url = new URL(this.tableData.inviteurl);
          let Code = new URLSearchParams(Url.search);
          this.tableData.invitecode = Code.get("invite_code");
        }
      }
    },

    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    },
  }
};
</script>
